module.exports = __webpack_public_path__ + "static/Off-shore-model-13e7c6054ad3dc2f2c3834018fb85712.png";